// extracted by mini-css-extract-plugin
export var collapsedSummary = "_po-0";